import { CompanySearchParams } from 'shared/generated-models';

export const getFiltersText = (values: CompanySearchParams) => {
	const cleanParams: Record<string, any> = Object.entries(values)
		.filter(([_, v]) => (Array.isArray(v) ? v.length > 0 : v != null))
		.reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});

	let result = [];

	if ('skills' in cleanParams) result.push(cleanParams['skills'].map((s: string) => s.trim()).join(', '));
	if ('city' in cleanParams) result.push(cleanParams['city'].map((s: string) => s.trim()).join(', '));
	if ('country' in cleanParams) result.push(cleanParams['country'].map((s: string) => s.trim()).join(', '));
	if ('company_domain' in cleanParams)
		result.push(cleanParams['company_domain'].map((s: string) => s.trim()).join(', '));
	if ('website_keywords' in cleanParams)
		result.push(cleanParams['website_keywords'].map((s: string) => s.trim()).join(', '));
	if ('headcount' in cleanParams) result.push(cleanParams['headcount'].map((s: string) => s.trim()).join(', '));

	return result.join(', ');
};
